
    import Vue from "vue";

    const END_POINT = "/cardPaymentConfig";

    const getCardPaymentConfig = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllCardPaymentConfigs = data => Vue.axios.get(END_POINT, {params: data});

    const createCardPaymentConfig = cardPaymentConfig => Vue.axios.post(END_POINT,  cardPaymentConfig );

    const createAllCardPaymentConfigs = CardPaymentConfigs => Vue.axios.post(END_POINT + "/all",  CardPaymentConfigs );

    const updateCardPaymentConfig = cardPaymentConfig => Vue.axios.put(END_POINT  + "/" + cardPaymentConfig.id,  cardPaymentConfig );

    const deleteCardPaymentConfig = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getCardPaymentConfig,
      getAllCardPaymentConfigs,
      createCardPaymentConfig,
      createAllCardPaymentConfigs,
      updateCardPaymentConfig,
      deleteCardPaymentConfig
    };
    